module.exports = __webpack_public_path__ + "img/sk-btp.e0927b47.png";